import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { ProductService } from "src/app/_service/product.service";
import { AlertifyService } from "src/app/_service/alertify.service";
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatTabChangeEvent,
} from "@angular/material";
import { ManufacturerService } from "src/app/_service/manufacturer.service";
import { EditManufacturerComponent } from "src/app/manufacturer/edit-manufacturer/edit-manufacturer.component";
import { Whmis2015Service } from "src/app/_service/whmis2015.service";
import { FileuploadComponent } from "src/app/fileupload/fileupload.component";
import { FileuploadService } from "src/app/_service/fileupload.service";
import { ManufacturerServerSearchComponent } from "src/app/manufacturerServerSearch/manufacturerServerSearch.component";
import { CreateManufacturerComponent } from "src/app/manufacturer/create-manufacturer/create-manufacturer.component";
import { TreeComponent } from "src/app/tree/tree.component";
import { Subject } from "rxjs";
import {
  filter,
  tap,
  takeUntil,
  debounceTime,
  map,
  delay,
} from "rxjs/operators";
import { AppCustomDirective } from "src/app/_extensions/app.validators";
import { BrowserDetectorService } from "src/app/_service/browserDetector.service";
import { DeleteConfirmationComponent } from "./deleteConfirmation/deleteConfirmation/deleteConfirmation.component";

@Component({
  selector: "edit-product",
  templateUrl: "./edit-product.component.html",
  styleUrls: ["./edit-product.component.css"],
})
export class EditProductComponent implements OnInit {
  @ViewChild(FileuploadComponent, { static: true })
  filepdf: FileuploadComponent;
  @ViewChild(ManufacturerServerSearchComponent, { static: true })
  manufacturerSearch: ManufacturerServerSearchComponent;
  @ViewChild(TreeComponent, { static: true }) locationTree: TreeComponent;

  DaterForm: FormGroup;

  constructor(
    private productService: ProductService,
    private alertify: AlertifyService,
    public fb: FormBuilder,
    private dialog: MatDialog,
    private fileService: FileuploadService,
    private manufacturerService: ManufacturerService,
    private whmis2015Service: Whmis2015Service,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    public detectBrowser: BrowserDetectorService
  ) {
    this.DaterForm = this.fb.group({
      FromDate: ["", [AppCustomDirective.fromDateValidator]],
    });

    this.productEditForm = fb.group({
      productNameFormControl: new FormControl("", [
        Validators.required,
        this.WhitespaceValidator,
      ]),
      productAliasControl: new FormControl("", []).clearValidators(),
      productCodeFormControl: new FormControl("", []).clearValidators(),
      // manufacturerFormControl : new FormControl('', [
      //   Validators.required,
      // ]),
      additionalSuppliersFormControl: new FormControl("", []).clearValidators(),

      creationDateFormControl: new FormControl("", []).clearValidators(),

      mostRecentRequestFormControl: new FormControl("", []).clearValidators(),

      lastModifiedDateFormControl: new FormControl("", []).clearValidators(),

      lastVerifiedFormControl: new FormControl("", []).clearValidators(),

      revisionDateFormControl: new FormControl("", []).clearValidators(),

      registrationFormControl: new FormControl("", []).clearValidators(),

      sdsOriginFormControl: new FormControl("", []).clearValidators(),

      exemptionClassFormControl: new FormControl("", []).clearValidators(),
      sdsFormatFormControl: new FormControl("", []).clearValidators(),
      whmisExemptFormControl: new FormControl("", []).clearValidators(),
      discontinuedFormControl: new FormControl("", []).clearValidators(),

      sdsAvailabilityFormControl: new FormControl("", []).clearValidators(),
      sdsHazardIdentificationFormControl: new FormControl(
        "",
        []
      ).clearValidators(),
      notesFormControl: new FormControl("", []).clearValidators(),

      hazardCategoryFormControl: new FormControl("", []).clearValidators(),

      hmisHealthRatingFormControl: new FormControl("", []).clearValidators(),
      hmisChronicRatingFormControl: new FormControl("", []).clearValidators(),

      hmisFlammabilityRatingFormControl: new FormControl(
        "",
        []
      ).clearValidators(),
      hmisReactivityFormControl: new FormControl("", []).clearValidators(),

      nfpaHealthRatingsFormControl: new FormControl("", []).clearValidators(),
      nfpaInstabilityFormControl: new FormControl("", []).clearValidators(),
      nfpaSpecificFormControl: new FormControl("", []).clearValidators(),
      nfpaFlammabilityFormControl: new FormControl("", []).clearValidators(),
      iarcFormControl: new FormControl("", []).clearValidators(),
      acgihFormControl: new FormControl("", []).clearValidators(),

      transportHazardClassFormControl: new FormControl(
        "",
        []
      ).clearValidators(),

      physicalStateFormControl: new FormControl("", []).clearValidators(),

      physicalHazardClassFormControl: new FormControl("", []).clearValidators(),

      healthHazardFormControl: new FormControl("", []).clearValidators(),
      acuteToxicityRouteFormControl: new FormControl("", []).clearValidators(),
      skinCorrosionRouteFormControl: new FormControl("", []).clearValidators(),
    });

    this.pictogramFormGroup = this.fb.group({
      pictograms: this.fb.array([]),
    });
  }

  productEditForm: FormGroup;
  pictogramFormGroup: FormGroup;
  protected _onDestroy = new Subject<void>();
  goToLocationTab: any;

  confirmModal = false;
  productRemoved: any;
  loading = false;

  manufacturers;
  selectedValue: any;
  selectedManufacturer: any;
  selectedManufacturerId: any;
  selectedMan: any;
  // tslint:disable-next-line: member-ordering
  selectedFileName: string = null;

  // tslint:disable-next-line: member-ordering
  selectedSDSOrigin: any;
  sdsOrigin: any;

  exemptionClass: any;
  selectedExemptionClass: any;

  categories: any;
  selectedCategories: any = [];

  hmisRatingshealth: any = [];
  selectedhmisRatingshealth: any = [];

  hmisRatingsChronic: any = [];
  selectedhmisRatingsChronic: any = [];

  hmisRatingsFlammability: any;
  selectedhmisRatingsFlammability: any;

  hmisRatingsReactivity: any;
  selectedhmisRatingsReactivity: any;

  nfpaRatingsHealth: any;
  selectednfpaRatingsHealth: any;

  nfpaRatingsInstability: any;
  selectednfpaRatingsInstability: any;

  nfpaRatingsSpecific: any;
  selectednfpaRatingsSpecific: any;

  nfparatingsFlammability: any;
  selectednfparatingsFlammability: any;

  iarc: any;
  selectedIarc: any = [];

  acgih: any;
  selectedacgih: any = [];

  transportHazard: any;
  selectedTransportHazard: any = [];

  physicalStates: any;
  selectedPhysicalStates: any = [];

  physicals: any;
  selectedPhysicalClass: any = [];

  healths: any;
  selectedHealthClass: any;
  acuteToxicity: any;
  skinCorrosionIrritation: any;

  acuteRoutes: any = [];
  skinRoutes: any = [];

  AcuteToxicityRoute: any;
  selectedAcuteToxicityRoute: any = [];

  SkinCorrosionIrritationRoute: any;
  selectedSkinCorrosionIrritation: any;

  pictograms: any = [];
  imageBind: any = [];
  pictogramValue: any = [];
  selectedCheckBoxes: any = [];
  productAlias: any;

  productDetail: any = [];

  fileInfo: any = null;

  updateModel: any = {};

  productId = this.passedData.product.productId;
  externalProductId: any;

  checkedNodes: any = null;
  timeForLocation: any;
  model: any = [];

  sdsAvailability: any;
  sdsAvailabilityChecked: any;
  sdsHazardIdentification: any;

  updatemodel: any = {};
  updatedProductId: any;
  fileExistsCheck: any;
  isModified = false;

  manufacturerValue: any;

  timeForSDSOrigin: any;
  timeForHealthCategory: any;
  timeForHmisRatingsHealth: any;
  timeForHMISRatingsChronic: any;
  timeForHMISRatingsFlammability: any;
  timeForHMISRatingsReactivity: any;
  timeForNFPARatingsHealth: any;
  timeForNFPARatingsInstability: any;
  timeForNFPARatingsSpecific: any;
  timeForNFPARatingsFlammability: any;
  timeForIARC: any;
  timeForACGIH: any;
  timeForTransportHazard: any;
  timeForPhysicalStates: any;
  timeForSelectedHealthHazardClass: any;
  ieVersion: any;

  revisionDate: any = {};
  lastVerifiedDate: any = {};
  mostRecentRequest: any = {};

  revisionFC: any;
  lastVerifiedDateFC: any;
  mostRecentRequestFC: any;

  formatValue: string;
  sdsFormat: SDSFormat[] = [
    { value: "1", viewValue: "GHS" },
    { value: "2", viewValue: "Other" },
  ];

  sdsFormatValue: string;
  MSDSFormatGroups: SDSFormatGroup[] = [
    {
      name: "SDS Format",
      format: [
        { value: "1", viewValue: "GHS" },
        { value: "2", viewValue: "Other" },
      ],
    },
  ];

  exemptValue: string;
  whmisExempt: WhmisExempt[] = [
    { value: "0", viewValue: "No" },
    { value: "1", viewValue: "Yes" },
  ];

  discontinuedValue: string;
  discontinuedObj: Discontinued[] = [
    { value: "0", viewValue: "No" },
    { value: "1", viewValue: "Yes" },
  ];

  AcuteToxicityGroups: AcuteToxicityGroup[] = [
    {
      name: "Acute toxity Route",
      status: [
        { value: "1", viewValue: "Oral" },
        { value: "2", viewValue: "Dermal" },
        { value: "3", viewValue: "Inhalation" },
        { value: "4", viewValue: "Unspecified" },
      ],
    },
  ];

  SkinCorrosionIrritationGroups: SkinCorrosionIrritationGroup[] = [
    {
      name: "Skin corrosion / irritation Route",
      status: [
        { value: "1", viewValue: "Skin" },
        { value: "2", viewValue: "Eye" },
        { value: "3", viewValue: "Respiratory" },
        { value: "4", viewValue: "Ingestion" },
        { value: "3", viewValue: "Unspecified" },
      ],
    },
  ];

  propagateChange = (_: any) => {};

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || "").trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  ngOnInit() {
    this.detectBrowser.DetectIE();
    this.getProdDetails();
    this.getSDSOriginDropDown();
    this.getCategoryDropDown();
    this.getHmisRatingshealthDropDown();
    this.getHmisRatingsChronicDropDown();
    this.getHmisRatingsFlammabilityDropDown();
    this.getHmisRatingsReactivityDropDown();

    this.manufacturerDropDown();
    this.pictogramReferences();
    this.healthClassDropDown();
    this.AcutehealthRoutes();
    this.SkinHealthRoutes();
    this.physicalClassDropDown();

    this.getNfpaRatingsHealthDropDown();
    this.getNfpaRatingsInstabilityDropDown();
    this.getNfpaRatingsSpecificDropDown();
    this.getNfparatingsFlammabilityDropDown();
    this.getIArcDropDown();
    this.getAcgihDropDown();
    this.getTransportHazardDropDown();
    this.getPhysicalStatesDropDown();
    this.getExemptionClassDropDown();

    this.getSDSFiles();
    this.ieVersion = this.getInternetExplorerVersion();

    this.revisionFC = this.productEditForm.get("revisionDateFormControl");
    this.lastVerifiedDateFC = this.productEditForm.get(
      "lastVerifiedFormControl"
    );
    this.mostRecentRequestFC = this.productEditForm.get(
      "mostRecentRequestFormControl"
    );
  }

  getInternetExplorerVersion() {
    let rv = -1;
    if (navigator.appName == "Microsoft Internet Explorer") {
      const ua = navigator.userAgent;
      const re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
      if (re.exec(ua) != null) {
        rv = parseFloat(RegExp.$1);
      }
    } else if (navigator.appName === "Netscape") {
      const ua = navigator.userAgent;
      const re = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})");
      if (re.exec(ua) != null) {
        rv = parseFloat(RegExp.$1);
      }
    }
    return rv;
  }

  show = false;
  ngAfterViewChecked() {
    const show = this.validateFormControl(this.productEditForm);
    if (show != this.show) {
      this.show = show;
      this.checkDateCondition(true);
      this.cdr.detectChanges();
    }
    this.productEditForm.get("lastVerifiedFormControl").value;
    this.cdr.detectChanges();
  }

  changeRevisionDate(event) {
    this.revisionDate = event.target.value;
    this.checkDateCondition();
  }

  changeLastVerifiedDate(event) {
    this.lastVerifiedDate = event.target.value;
    this.checkDateCondition();
  }

  changeMostRecentRequestDate(event) {
    this.mostRecentRequest = event.target.value;
    this.checkDateCondition();
  }

  dateReturnErrorMessage() {
    if (this.lastVerifiedDateFC.hasError("checkDateCondition")) {
      return "Last verified must be equal or greater than the Revision date";
    } 
    // else {
    //   return "Please enter a valid date";
    // }
  }

  checkDateCondition(flg = false) {
    if (flg) {
      if (isNaN(Date.parse(this.lastVerifiedDate))) {
        this.lastVerifiedDateFC.setErrors({ invalidDate: true });
      } else {
        this.lastVerifiedDateFC.setErrors({ invalidDate: null });
        this.lastVerifiedDateFC.updateValueAndValidity();
      }
    }
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    const p1 = Date.parse(
      new Date(this.revisionDate)
        .toLocaleString("en-US", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
        .replace(/[^ -~]/g, "")
    );
    const p2 = Date.parse(
      new Date(this.lastVerifiedDate)
        .toLocaleString("en-US", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
        .replace(/[^ -~]/g, "")
    );
    const result =
      this.revisionDate != null &&
      this.lastVerifiedDate != null &&
      !isNaN(p1) &&
      !isNaN(p2) &&
      p1 > p2;
    if (result) {
      this.lastVerifiedDateFC.setErrors({ checkDateCondition: true });
    } else {
      this.lastVerifiedDateFC.setErrors({ checkDateCondition: null });
      this.lastVerifiedDateFC.updateValueAndValidity();
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  public validateFormControl(control) {
    if (control.status === "VALID") {
      return true;
    } else {
      return false;
    }
  }

  locationValidator(locationTreeId) {
    if (locationTreeId !== undefined) {
      for (const locationId of locationTreeId.checklistSelection._selection) {
        if (locationId.authorityUnitId !== undefined) {
          return true;
        } else {
          return false;
        }
      }
    }
  }

  public findInvalidControls() {
    const invalid = [];
  }

  onSDSAvailabilityChecked($event) {
    console.log($event.checked);
    if ($event.checked) {
      this.sdsAvailabilityChecked = 1;
    } else {
      this.sdsAvailabilityChecked = 0;
    }
  }

  hazardIdentification($event) {
    console.log($event.checked);
    if ($event.checked) {
      return (this.sdsHazardIdentification = 1);
    } else {
      this.sdsHazardIdentification = 0;
    }
  }

  // get pdf file
  getSDSFiles() {
    const propId = this.productId;
    const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    };
    const blobToFile = (theBlob: Blob, fileName: string): File => {
      const b: any = theBlob;
      b.lastModifiedDate = new Date();
      b.name = fileName;
      return b as File;
    };

    return this.fileService.DownloadFile(propId).subscribe((res) => {
      if (res == null) {
        return;
      }
      this.fileInfo = res;
      const contentType = "application/pdf";
      const blob = b64toBlob(this.fileInfo.base64File, contentType);
      const blobUrl = URL.createObjectURL(blob);
      const bfile = blobToFile(blob, this.fileInfo.fileName);
      this.filepdf.files.push(bfile);
      this.filepdf.fileUrl = blobUrl;
      this.filepdf.checkedTime = 0;
    });
  }

  getProdDetails() {
    return this.productService
      .getProductDetails(this.productId)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        this.productDetail = res[0];
        console.log(this.productDetail);
        this.externalProductId = this.productDetail.externalProductId;
        this.imageBind = this.productDetail.pictogram;
        this.revisionDate = this.productDetail.revisionDate;
        this.lastVerifiedDate = this.productDetail.lastVerified;
        this.mostRecentRequest = this.productDetail.mostRecentRequest;
        this.sdsFormatValue = this.productDetail.sdsFormat === 4 ? "1" : "2";
        this.discontinuedValue =
          this.productDetail.discontinued === false ? "0" : "1";
        this.productAlias = this.productDetail.productAlias;

        this.sdsAvailability =
          this.productDetail.sdsAvailability === false ? false : true;
        this.productEditForm
          .get("sdsAvailabilityFormControl")
          .setValue(this.sdsAvailability);

        this.sdsHazardIdentification =
          this.productDetail.sdsHazardIdentification === false ? false : true;
        this.productEditForm
          .get("sdsHazardIdentificationFormControl")
          .setValue(this.sdsHazardIdentification);

        this.exemptValue = this.productDetail.whmisExempt === false ? "0" : "1";
        this.selectedExemptionClass = this.productDetail.exemptionClass;
        this.selectedSDSOrigin = this.productDetail.sdsOrigin;
        this.selectedCategories = this.productDetail.hazardCategoryId;

        this.timeForHmisRatingsHealth = setInterval(() => {
          this.getHmisRatingshealthDropDown();
        }, 10);
        this.timeForHMISRatingsChronic = setInterval(() => {
          this.getHmisRatingsChronicDropDown();
        }, 10);
        this.timeForHMISRatingsFlammability = setInterval(() => {
          this.getHmisRatingsFlammabilityDropDown();
        }, 10);
        this.timeForHMISRatingsReactivity = setInterval(() => {
          this.getHmisRatingsReactivityDropDown();
        }, 10);

        this.timeForNFPARatingsHealth = setInterval(() => {
          this.getNfpaRatingsHealthDropDown();
        }, 10);
        this.timeForNFPARatingsInstability = setInterval(() => {
          this.getNfpaRatingsInstabilityDropDown();
        }, 10);
        this.timeForNFPARatingsSpecific = setInterval(() => {
          this.getNfpaRatingsSpecificDropDown();
        }, 10);
        this.timeForNFPARatingsFlammability = setInterval(() => {
          this.getNfparatingsFlammabilityDropDown();
        }, 10);

        this.selectedIarc = this.productDetail.iarc;
        this.selectedacgih = this.productDetail.acgih;
        this.timeForTransportHazard = setInterval(() => {
          this.getTransportHazardDropDown();
        }, 10);

        this.selectedPhysicalStates = this.productDetail.physicalState;

        this.selectedPhysicalClass = this.productDetail.physicalHazardClass;

        this.selectedHealthClass = this.productDetail.healthHazardClass;

        this.timeForSelectedHealthHazardClass = setInterval(() => {
          this.onSelectedHealthHazardClass(this.selectedHealthClass);
        }, 10);

        this.selectedAcuteToxicityRoute = this.productDetail.acuteToxRoute;

        this.selectedSkinCorrosionIrritation =
          this.productDetail.skinIrrCorrRoute;

        this.timeForLocation = setInterval(() => {
          this.getLocationTree();
        }, 10);

        this.revisionFC.setValue(new Date(this.revisionDate));
        this.lastVerifiedDateFC.setValue(new Date(this.lastVerifiedDate));
        this.mostRecentRequestFC.setValue(new Date(this.mostRecentRequest));

        this.revisionFC = this.productEditForm.get("revisionDateFormControl");
        this.lastVerifiedDateFC = this.productEditForm.get(
          "lastVerifiedFormControl"
        );
        this.mostRecentRequestFC = this.productEditForm.get(
          "mostRecentRequestFormControl"
        );
        this.checkDateCondition(true);

        this.revisionFC.markAsTouched();
        this.lastVerifiedDateFC.markAsTouched();
        this.mostRecentRequestFC.markAsTouched();
      });
  }

  pictogramReferences() {
    return this.whmis2015Service.getPictograms().subscribe((res) => {
      this.pictograms = res;
      console.log(this.pictograms);
    });
  }

  checkedBoxeOpacity(id) {
    if (this.ieVersion < 10) {
      return 1;
    }
    return this.imageBind.find((x) => x === id) == null ? 0.5 : 1;
  }

  checkedBoxes(id) {
    return this.imageBind.find((x) => x == id) == null
      ? "grayscale(100%)"
      : "none";
  }

  onChangePictogram($event) {
    if ($event.checked) {
      this.imageBind.push($event.source.value);
    } else {
      const i = this.imageBind.findIndex((x) => x === $event.source.value);
      this.imageBind.splice(i, 1);
    }
  }

  isChecked(id) {
    return this.imageBind.find((x) => x === id) == null ? false : true;
  }

  SkinHealthRoutes() {
    return this.whmis2015Service
      .getSkinIrrCorrHealthRoutes()
      .subscribe((res) => {
        this.skinRoutes = res;
      });
  }

  onSelectSkinCorrosionIrritation(selectedSkinCorrosionIrritation) {
    this.SkinCorrosionIrritationRoute = selectedSkinCorrosionIrritation;
    console.log(selectedSkinCorrosionIrritation);
  }

  AcutehealthRoutes() {
    return this.whmis2015Service.getAcuteHealthRoutes().subscribe((res) => {
      this.acuteRoutes = res;
    });
  }

  onSelectAcuteToxicityRoute(selectedAcuteToxicityRoute) {
    console.log(selectedAcuteToxicityRoute);
  }

  healthClassDropDown() {
    return this.whmis2015Service.getHealthClass().subscribe((res) => {
      this.healths = res;
    });
  }

  onSelectedHealthHazardClass(selectedHealthClass) {
    if (this.healths !== undefined && selectedHealthClass !== undefined) {
      const acuteToxValResponse = this.healths.find(
        (x) => x.healthClassName == "Acute toxicity"
      );
      const skinCorvalResponse = this.healths.find(
        (x) => x.healthClassName == "Skin corrosion/irritation"
      );
      this.acuteToxicity = false;
      this.skinCorrosionIrritation = false;
      console.log(selectedHealthClass);
      if (selectedHealthClass !== undefined) {
        for (const selectedValue of selectedHealthClass) {
          if (selectedValue === acuteToxValResponse.healthClassId) {
            this.acuteToxicity = true;
          }
          if (selectedValue === skinCorvalResponse.healthClassId) {
            this.skinCorrosionIrritation = true;
          }
        }
      }

      const selectedAcuteTox = selectedHealthClass.find(
        (x) =>
          x.healthClassName == acuteToxValResponse.healthClassName &&
          x.length !== 0
      );

      if (selectedAcuteTox === undefined && !this.acuteToxicity) {
        this.productEditForm.get("acuteToxicityRouteFormControl").reset();
      }

      const selectedSkinIrr = selectedHealthClass.find(
        (x) =>
          x.healthClassName == skinCorvalResponse.healthClassName &&
          x.length !== 0
      );

      if (selectedSkinIrr === undefined && !this.skinCorrosionIrritation) {
        this.productEditForm.get("skinCorrosionRouteFormControl").reset();
      }
      clearInterval(this.timeForSelectedHealthHazardClass);
    }
  }

  onSelectedPhysicalHazardClass(selectedPhysicalClass) {
    console.log(selectedPhysicalClass);
  }

  physicalClassDropDown() {
    return this.whmis2015Service.getPhysicalClass().subscribe((res) => {
      this.physicals = res;
    });
  }

  getPhysicalStatesDropDown() {
    return this.whmis2015Service.getPhysicalStates().subscribe((res) => {
      this.physicalStates = res;
    });
  }

  onSelectedPhysicalStates(selectedPhysicalStates) {
    console.log(selectedPhysicalStates);
  }

  clickPhysicalState(physicalState) {
    if (physicalState.physicalStateId === 19) {
      this.selectedPhysicalStates = [19];
    } else if (physicalState.physicalStateId === 28) {
      this.selectedPhysicalStates = [28];
    } else {
      this.selectedPhysicalStates = this.selectedPhysicalStates.filter(
        (x) => x !== 19 && x !== 28
      );
    }
  }

  getTransportHazardDropDown() {
    return this.whmis2015Service
      .getTransportHazardClasses()
      .subscribe((res) => {
        this.transportHazard = res;

        if (
          this.transportHazard !== undefined &&
          this.productDetail.transportHazardClass !== undefined
        ) {
          this.selectedTransportHazard =
            this.productDetail.transportHazardClass.length === 0
              ? this.transportHazard
                  .map(({ transportHazardId }) => transportHazardId)
                  .slice(21, 22)
              : this.productDetail.transportHazardClass;
          clearInterval(this.timeForTransportHazard);
        }
      });
  }

  onSelectedTransportHazardClasses(selectedTransportHazard) {
    console.log(selectedTransportHazard);
  }

  getAcgihDropDown() {
    return this.whmis2015Service.getAllAcgihValues().subscribe((res) => {
      this.acgih = res;
    });
  }

  onSelectedAcgih(selectedacgih) {
    console.log(selectedacgih);
  }

  getIArcDropDown() {
    return this.whmis2015Service.getAllIArcValues().subscribe((res) => {
      this.iarc = res;
    });
  }

  onSelectedIArc(selectedIarc) {
    console.log(selectedIarc);
  }

  getNfparatingsFlammabilityDropDown() {
    return this.whmis2015Service
      .getAllNfpaRatingsFlammabilityValues()
      .subscribe((res) => {
        this.nfparatingsFlammability = res;

        if (
          this.nfparatingsFlammability !== undefined &&
          this.productDetail.nfpaFlammabilityRatings !== undefined
        ) {
          this.selectednfparatingsFlammability =
            this.productDetail.nfpaFlammabilityRatings.length === 0
              ? this.nfparatingsFlammability[0].nfparatingsFlammabilityId
              : this.productDetail.nfpaFlammabilityRatings[0];
          clearInterval(this.timeForNFPARatingsFlammability);
        }
      });
  }

  onSelectedNfparatingsFlammability(selectednfparatingsFlammability) {
    console.log(selectednfparatingsFlammability);
  }

  getNfpaRatingsSpecificDropDown() {
    return this.whmis2015Service
      .getAllNfpaRatingsSpecific()
      .subscribe((res) => {
        this.nfpaRatingsSpecific = res;

        if (
          this.nfpaRatingsSpecific !== undefined &&
          this.productDetail.nfpaSpecificRatings !== undefined
        ) {
          this.selectednfpaRatingsSpecific =
            this.productDetail.nfpaSpecificRatings.length === 0
              ? this.nfpaRatingsSpecific[0].nfparatingsSpecificId
              : this.productDetail.nfpaSpecificRatings[0];
          clearInterval(this.timeForNFPARatingsSpecific);
        }
      });
  }

  onSelectedNfpaRatingsSpecific(selectednfpaRatingsSpecific) {
    console.log(selectednfpaRatingsSpecific);
  }

  getNfpaRatingsInstabilityDropDown() {
    return this.whmis2015Service
      .getAllNfpaRatingsInstability()
      .subscribe((res) => {
        this.nfpaRatingsInstability = res;

        if (
          this.nfpaRatingsInstability !== undefined &&
          this.productDetail.nfpaInstabilityRatings !== undefined
        ) {
          this.selectednfpaRatingsInstability =
            this.productDetail.nfpaInstabilityRatings.length === 0
              ? this.nfpaRatingsInstability[0].nfparatingsInstabilityId
              : this.productDetail.nfpaInstabilityRatings[0];
          clearInterval(this.timeForNFPARatingsInstability);
        }
      });
  }

  onSelectedNfpaRatingsInstability(selectednfpaRatingsInstability) {
    console.log(selectednfpaRatingsInstability);
  }

  getNfpaRatingsHealthDropDown() {
    return this.whmis2015Service
      .getAllNFPARatingsHealthValues()
      .subscribe((res) => {
        this.nfpaRatingsHealth = res;

        if (
          this.nfpaRatingsHealth !== undefined &&
          this.productDetail.nfpaHealthRatings !== undefined
        ) {
          this.selectednfpaRatingsHealth =
            this.productDetail.nfpaHealthRatings.length === 0
              ? this.nfpaRatingsHealth[0].nfparatingsHealthId
              : this.productDetail.nfpaHealthRatings[0];
          clearInterval(this.timeForNFPARatingsHealth);
        }
      });
  }

  onSelectedNfpaRatingsHealth(selectednfpaRatingsHealth) {
    console.log(selectednfpaRatingsHealth);
  }

  getHmisRatingsReactivityDropDown() {
    return this.whmis2015Service
      .getAllHmisRatingsReactivity()
      .subscribe((res) => {
        this.hmisRatingsReactivity = res;

        if (
          this.hmisRatingsReactivity !== undefined &&
          this.productDetail.hmisReactivityRatings !== undefined
        ) {
          this.selectedhmisRatingsReactivity =
            this.productDetail.hmisReactivityRatings.length === 0
              ? this.hmisRatingsReactivity[0].hmisratingsReactivityId
              : this.productDetail.hmisReactivityRatings[0];
          clearInterval(this.timeForHMISRatingsReactivity);
        }
      });
  }

  onSelectedHmisRatingsReactivity(selectedhmisRatingsReactivity) {
    console.log(selectedhmisRatingsReactivity);
  }

  getHmisRatingsFlammabilityDropDown() {
    return this.whmis2015Service
      .getAllHmisRatingsFlammability()
      .subscribe((res) => {
        this.hmisRatingsFlammability = res;

        if (
          this.hmisRatingsFlammability !== undefined &&
          this.productDetail.hmisFlammabilityRatings !== undefined
        ) {
          this.selectedhmisRatingsFlammability =
            this.productDetail.hmisFlammabilityRatings.length === 0
              ? this.hmisRatingsFlammability[0].hmisratingsFlammabilityId
              : this.productDetail.hmisFlammabilityRatings[0];
          clearInterval(this.timeForHMISRatingsFlammability);
        }
      });
  }

  onSelectedHmisRatingsFlammability(selectedhmisRatingsFlammability) {
    console.log(selectedhmisRatingsFlammability);
  }

  getHmisRatingsChronicDropDown() {
    return this.whmis2015Service.getAllHmisRatingsChronic().subscribe((res) => {
      this.hmisRatingsChronic = res;

      if (
        this.hmisRatingsChronic !== undefined &&
        this.productDetail.hmisChronicRatings !== undefined
      ) {
        this.selectedhmisRatingsChronic =
          this.productDetail.hmisChronicRatings.length === 0
            ? this.hmisRatingsChronic[0].hmisratingsChronicId
            : this.productDetail.hmisChronicRatings[0];
        clearInterval(this.timeForHMISRatingsChronic);
      }
    });
  }

  onSelectedHmisRatingsChronic(selectedhmisRatingsChronic) {
    console.log(selectedhmisRatingsChronic);
  }

  getHmisRatingshealthDropDown() {
    return this.whmis2015Service.getAllHmisRatingsHealth().subscribe((res) => {
      this.hmisRatingshealth = res;

      if (
        this.hmisRatingshealth !== undefined &&
        this.productDetail.hmisHealthRatings !== undefined
      ) {
        this.selectedhmisRatingshealth =
          this.productDetail.hmisHealthRatings.length === 0
            ? this.hmisRatingshealth[0].hmisratingsHealthId
            : this.productDetail.hmisHealthRatings[0];
        clearInterval(this.timeForHmisRatingsHealth);
      }
    });
  }

  onSelectedHmisRatingshealth(selectedhmisRatingshealth) {
    console.log(selectedhmisRatingshealth);
  }

  getCategoryDropDown() {
    return this.whmis2015Service.getHazardCategory().subscribe((res) => {
      this.categories = res;
    });
  }

  onSelectedCategories(selectedCategories) {
    console.log(selectedCategories);
  }

  getExemptionClassDropDown() {
    return this.whmis2015Service.getExemptionClass().subscribe((res) => {
      this.exemptionClass = res;
    });
  }

  onSelectedExemptionClass(selectedExemptionClass) {
    console.log(selectedExemptionClass);
  }

  getSDSOriginDropDown() {
    return this.whmis2015Service.getSDSOrigin().subscribe((res) => {
      this.sdsOrigin = res;
    });
  }

  onSelectedSDSOrigin(selectedSDSOrigin) {
    console.log(selectedSDSOrigin);
  }

  changeListener($event): void {
    this.readThis($event.target);
    console.log($event);
  }

  readThis(inputValue: any): void {
    const file: File = inputValue.files[0];
    const myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.propagateChange(myReader.result);
      this.selectedFileName = file.name;
    };
    myReader.readAsDataURL(file);
  }

     getLocationTree() {
      if (this.locationTree.location.length === 0) {
        return;
      }
      this.checkedNodes = [];
      for (const node of this.locationTree.location) {
        this.markLocations(node, 0);
      }
      clearInterval(this.timeForLocation);
      this.locationTree.checklistSelection.select(...this.checkedNodes);
      
      this.checkedNodes.forEach(node => {
        this.expandParents(node);
      });
    }
  
    expandParents(node: any) {
      let parent = this.locationTree.getParentNode(node);
      while (parent) {
        this.locationTree.treeControl.expand(parent);
        parent = this.locationTree.getParentNode(parent);
      }
    }

  markLocations(node: any, level: number) {
    if (this.productDetail.locationId.indexOf(node.authorityUnitId) > -1) {
      const flat = this.locationTree.transformer(node, level);
      this.locationTree.treeControl.expand(flat);
      this.checkedNodes.push(flat);
    }
    if (node.children != null && node.children.length > 0) {
      for (const chd of node.children) {
        this.markLocations(chd, level + 1);
      }
    }
  }

  openManufacturerEditPage(id) {
    console.log(id);
    const dialogRef = this.dialog.open(EditManufacturerComponent, {
      width: "1000px",
      data: {
        manufacturerId: id,
        selectedManu: this.selectedMan,
        serverSideSearch: this.manufacturerSearch,
      },
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe((result) => {
      // returns true or false
      if (dialogRef.componentInstance.isModified) {
        this.manufacturerDropDown();
      }
    });
  }

  openManufacturerCreatePage() {
    const dialogRef = this.dialog.open(CreateManufacturerComponent, {
      width: "1000px",
    });
    const subscribeDialog =
      dialogRef.componentInstance.setManufacturer.subscribe((data) => {
        this.manufacturerSearch.bankServerSideCtrl.setValue(data.body);
        this.manufacturerSearch.placeholder = data.body.name;
      });
    dialogRef.afterClosed().subscribe((result) => {
      subscribeDialog.unsubscribe();
      // this.manufacturerDropDown();
      dialogRef.disableClose = true;
    });
  }

  onSelectManufacturers(selected) {
    this.selectedManufacturer = selected;
    console.log(selected);
  }
  manufacturerDropDown() {
    this.manufacturerSearch.bankServerSideCtrl.valueChanges.subscribe(() => {
      // tslint:disable-next-line: max-line-length
      this.selectedManufacturerId =
        this.manufacturerSearch.bankServerSideCtrl.value == null
          ? null
          : this.manufacturerSearch.bankServerSideCtrl.value.manufacturerId;
    });
    return this.manufacturerService
      .GetManufacturerById(this.productId)
      .subscribe((res) => {
        this.selectedMan = res;
        this.manufacturerSearch.bankServerSideCtrl.setValue(this.selectedMan);
        this.manufacturerSearch.bankServerSideFilteringCtrl.setValue(
          this.selectedMan.manufacturerName
        );
        console.log("manufacturer");
        this.manufacturerSearch.placeholder = this.selectedMan.manufacturerName;
        console.log(this.manufacturerSearch.bankServerSideCtrl.value);
        console.log(this.manufacturerSearch.bankServerSideFilteringCtrl.value);
      });
  }

  testtesttest = false;
  moveToSelectedTab(tabName: string) {
    for (
      let i = 0;
      i < document.querySelectorAll(".mat-tab-label-content").length;
      i++
    ) {
      if (!this.productEditForm.invalid) {
        this.testtesttest = true;
        if (
          (<HTMLElement>document.querySelectorAll(".mat-tab-label-content")[i])
            .innerText == tabName
        ) {
          (<HTMLElement>document.querySelectorAll(".mat-tab-label")[i]).click();
        }
      } else {
        this.testtesttest = false;
        return null;
      }
    }
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent) {
    this.goToLocationTab = tabChangeEvent.index;
  }

  moveToLocationTab() {
    if (this.goToLocationTab == 3) {
      for (
        let i = 0;
        i < document.querySelectorAll(".mat-tab-label-content").length;
        i++
      ) {
        (<HTMLElement>document.querySelectorAll(".mat-tab-label")[i]).click();
      }
    }
  }

  removeProduct() {
    this.loading = true;
    return this.productService.removeProduct(this.productId).subscribe(
      (res) => {
        this.productRemoved = res.headers.get("productremoved");
        this.confirmModal = false;
        // this.dialog.closeAll();
        if (this.productRemoved) {
          this.alertify.message(this.productRemoved);
          this.isModified = true;
          this.loading = false;
          this.dialog.closeAll();
        } else {
          this.alertify.error("Please try again later");
          this.loading = false;
        }
      },
      (error) => {
        this.alertify.error("Something went wrong. Please try again.");
        this.loading = false;
      }
    );
  }

  dontDeleteProduct() {
    this.confirmModal = false;
  }

  removeSelectedProduct() {
    this.confirmModal = true;
  }

  updateProductInformation() {
    console.log(this.productEditForm.controls);

    this.updatemodel.ProductName = this.productEditForm
      .get("productNameFormControl")
      .value.trim();
    this.updatemodel.ProductAlias = this.productEditForm
      .get("productAliasControl")
      .value.trim();
    this.updatemodel.ProductCode = this.productEditForm
      .get("productCodeFormControl")
      .value.trim();
    this.updatemodel.ManufacturerId = this.selectedManufacturerId;
    this.updatemodel.AdditionalSuppliers = this.productEditForm
      .get("additionalSuppliersFormControl")
      .value.trim();

    this.updatemodel.LastVerified = this.lastVerifiedDate;
    this.updatemodel.RevisionDate = this.revisionDate;
    this.updatemodel.CreationDate = this.productEditForm.get(
      "creationDateFormControl"
    ).value;
    this.updatemodel.MostRecentRequestDate = this.productEditForm.get(
      "mostRecentRequestFormControl"
    ).value;
    this.updatemodel.LastModified = this.productEditForm.get(
      "lastModifiedDateFormControl"
    ).value;

    this.updatemodel.RegistrationNumber =
      this.productEditForm.get("registrationFormControl").value == null
        ? null
        : this.productEditForm.get("registrationFormControl").value.trim();
    this.updatemodel.SDSOrigin = this.productEditForm.get(
      "sdsOriginFormControl"
    ).value;
    this.updatemodel.ExemptionClass =
      this.productEditForm.get("exemptionClassFormControl").value == null
        ? null
        : this.productEditForm.get("exemptionClassFormControl").value;
    this.updatemodel.SDSFormat = this.productEditForm.get(
      "sdsFormatFormControl"
    ).value;
    this.updatemodel.WHMISExempt =
      this.productEditForm.get("whmisExemptFormControl").value == "0" ? 0 : 1;
    this.updatemodel.Discontinued =
      this.productEditForm.get("discontinuedFormControl").value == "0" ? 0 : 1;
    this.updatemodel.SDSAvailability =
      this.productEditForm.get("sdsAvailabilityFormControl").value == true
        ? 1
        : 0;
    this.updatemodel.sdsHazardIdentification =
      this.productEditForm.get("sdsHazardIdentificationFormControl").value ==
      true
        ? 1
        : 0;

    this.updatemodel.Pictogram = this.imageBind;
    this.updatemodel.Notes =
      this.productEditForm.get("notesFormControl").value == null
        ? null
        : this.productEditForm.get("notesFormControl").value.trim();
    this.updatemodel.HazardCategoryId = this.productEditForm.get(
      "hazardCategoryFormControl"
    ).value;

    this.updatemodel.HMISHealthRatings = this.productEditForm.get(
      "hmisHealthRatingFormControl"
    ).value;
    this.updatemodel.HMISChronicRatings = this.productEditForm.get(
      "hmisChronicRatingFormControl"
    ).value;
    this.updatemodel.HMISFlammabilityRatings = this.productEditForm.get(
      "hmisFlammabilityRatingFormControl"
    ).value;
    this.updatemodel.HMISReactivityRatings = this.productEditForm.get(
      "hmisReactivityFormControl"
    ).value;
    this.updatemodel.NFPAHealthRatings = this.productEditForm.get(
      "nfpaHealthRatingsFormControl"
    ).value;
    this.updatemodel.NFPAInstabilityRatings = this.productEditForm.get(
      "nfpaInstabilityFormControl"
    ).value;
    this.updatemodel.NFPASpecificRatings = this.productEditForm.get(
      "nfpaSpecificFormControl"
    ).value;
    this.updatemodel.NFPAFlammabilityRatings = this.productEditForm.get(
      "nfpaFlammabilityFormControl"
    ).value;
    this.updatemodel.IARC = this.productEditForm.get("iarcFormControl").value;
    this.updatemodel.ACGIH = this.productEditForm.get("acgihFormControl").value;
    this.updatemodel.TransportHazardClass = this.productEditForm.get(
      "transportHazardClassFormControl"
    ).value;
    this.updatemodel.PhysicalState = this.productEditForm.get(
      "physicalStateFormControl"
    ).value;
    this.updatemodel.PhysicalHazardClass =
      this.productEditForm.get("physicalHazardClassFormControl").value == null
        ? null
        : this.productEditForm.get("physicalHazardClassFormControl").value;
    this.updatemodel.HealthHazardClass =
      this.productEditForm.get("healthHazardFormControl").value == null
        ? null
        : this.productEditForm.get("healthHazardFormControl").value;
    this.updatemodel.AcuteToxRoute =
      this.productEditForm.get("acuteToxicityRouteFormControl").value == null
        ? null
        : this.productEditForm.get("acuteToxicityRouteFormControl").value;
    this.updatemodel.SkinIrrCorrRoute =
      this.productEditForm.get("skinCorrosionRouteFormControl").value == null
        ? null
        : this.productEditForm.get("skinCorrosionRouteFormControl").value;
    this.updatemodel.LocationId = [];
    for (const loc of this.locationTree.checklistSelection.selected) {
      this.updatemodel.LocationId.push(loc.authorityUnitId);
    }
    let formData = new FormData();
    if (this.filepdf.files.length === 0) {
      this.updatemodel.FileName = null;
      formData = null;
    } else {
      this.updatemodel.FileName = this.filepdf.files[0].name;
      formData.append(this.filepdf.files[0].name, this.filepdf.files[0]);
    }
    console.log(this.updatemodel);
    return this.productService
      .updateProduct(this.productId, this.updatemodel)
      .subscribe(
        (res) => {
          this.fileExistsCheck = res.headers.get("fileCheck");
          if (this.fileExistsCheck) {
            this.alertify.error(this.fileExistsCheck);
          } else {
            this.updatedProductId = res.headers.get("productId");
            const updatedProductId = +this.updatedProductId;
            if (this.filepdf.checkedTime > 0) {
              this.fileService.UploadFile(updatedProductId, formData);
            }
            this.isModified = true;
            // this.dialog.closeAll();
            this.alertify.success("Product has been updated successfully");
          }
        },
        (error) => {
          this.alertify.error("Something went wrong, please try again");
        }
      );
  }
}

export interface SDSFormat {
  value: string;
  viewValue: string;
}

export interface SDSFormatGroup {
  disabled?: boolean;
  name: string;
  format: SDSFormat[];
}

export interface WhmisExempt {
  value: string;
  viewValue: string;
}

export interface Discontinued {
  value: string;
  viewValue: string;
}

export interface AcuteToxicity {
  value: string;
  viewValue: string;
}

export interface AcuteToxicityGroup {
  disabled?: boolean;
  name: string;
  status: AcuteToxicity[];
}

export interface SkinCorrIrritation {
  value: string;
  viewValue: string;
}

export interface SkinCorrosionIrritationGroup {
  disabled?: boolean;
  name: string;
  status: SkinCorrIrritation[];
}

export class UpdateProductModel {
  ProductName: string;
  ProductAlias: string;
  ProductCode: string;
  ManufacturerId: number;
  AdditionalSuppliers: string;
  CreationDate: string;
  LastModified: string;
  LastVerified: string;
  RevisionDate: string;
  RegistrationNumber: string;
  SDSOrigin: any;
  ExemptionClass: any;
  SDSFormat: any;
  WHMISExempt: any;
  Discontinued: any;
  Pictogram: any;
  Notes: string;
  HazardCategoryId: any;
  HMISHealthRatings: any;
  HMISChronicRatings: any;
  HMISFlammabilityRatings: any;
  HMISReactivityRatings: any;
  NFPAHealthRatings: any;
  NFPAInstabilityRatings: any;
  NFPASpecificRatings: any;
  NFPAFlammabilityRatings: any;
  IARC: any;
  ACGIH: any;
  TransportHazardClass: any;
  PhysicalState: any;
  PhysicalHazardClass: any;
  HealthHazardClass: any;
  AcuteToxRoute: any;
  SkinIrrCorrRoute: any;
  FileName: string;
  LocationId: any;
}
